const LS_KEY_LANGUAGE = 'pgu-yezh__language';

export const languages = {
  bzh: 'bzh',
  ja: 'ja',
  it: 'it',
  de: 'de',
};

export const saveLanguageInStorage = (lg) => {
  localStorage.setItem(LS_KEY_LANGUAGE, lg);
};

export const removeLanguageInStorage = () => {
  localStorage.removeItem(LS_KEY_LANGUAGE);
};

export const getLanguageFromStorage = () => {
  return localStorage.getItem(LS_KEY_LANGUAGE);
};
